import React from 'react';
import "./NavBar.css"
import logo from '../../assets/logo.png'
import pic from '../../assets/pic.png'

const NavBar = () => {
   return (
      <nav className='nav'>
         <div className=''>
            <img src={logo} alt="" />
            <p>Daily Exercise</p>
         </div>
        
         <div className=''> 
            <img src={pic} alt="" />


            <a href="/about">Esa Ruhullah</a>

         </div>
      </nav>
   );
};

export default NavBar;